import React from 'react';
import { Grid, Skeleton, Typography } from '@mui/material';
import { ContactDetailsBox } from '@/components/blocks/account/contactDetails/ContactDetailBox/ContactDetailBox';
import { ACCOUNT_CONTACT_DETAILS_PHRASES } from '@/consts/phrases/accountPhrases';
import { usePhrase } from '@/hooks';

export const AccountContactDetailsFormSkeleton = () => {
    const { t } = usePhrase();

    return (
        <>
            <ContactDetailsBox type="email">
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Skeleton height={50} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Skeleton height={50} />
                    </Grid>
                </Grid>
            </ContactDetailsBox>
            <ContactDetailsBox type="phone">
                <Typography variant="subtitle2" sx={{ my: 4, fontWeight: 'bold' }}>
                    {t(ACCOUNT_CONTACT_DETAILS_PHRASES.PRIMARY)}
                </Typography>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Skeleton height={50} />
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Skeleton height={50} />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Skeleton height={50} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Skeleton height={50} />
                    </Grid>
                </Grid>
                <Typography variant="subtitle2" sx={{ my: 4, fontWeight: 'bold' }}>
                    {t(ACCOUNT_CONTACT_DETAILS_PHRASES.ALTERNATIVE_PHONE)}
                </Typography>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <Skeleton height={50} />
                    </Grid>
                    <Grid size={12}>
                        <Skeleton height={50} />
                    </Grid>
                    <Grid size={12}>
                        <Skeleton height={50} />
                    </Grid>
                </Grid>
                <Grid
                    container
                    sx={{
                        justifyContent: 'flex-end',
                        marginTop: 2,
                    }}
                >
                    <Skeleton height={50} width={80} />
                </Grid>
            </ContactDetailsBox>
        </>
    );
};
